<div class="modal-header">
    <h4 class="modal-title">Add Documents</h4>
</div>
<!-- <div class="modal-body" (keyup.esc)="close()" (keyup.enter)="save()"> -->
<div class="modal-body">
    <dx-form [formData]="attachment" [colCount]="1">
        @if(fileUploaded){
        <dxi-item dataField="created" [label]="{ text: 'Date' }" [editorOptions]="{ disabled: true, width: '150px', format: 'shortDate' }"></dxi-item>
        <dxi-item dataField="name" [editorOptions]="{ disabled: !fileUploaded }"></dxi-item>
        <dxi-item dataField="filename" [editorOptions]="{ disabled: true }"></dxi-item>
        } @if(!fileUploaded){

        <dxi-item itemType="group" caption="Attachments">
            <dxi-item>
                <div *dxTemplate>
                    <dx-file-uploader
                        name="fileUpload"
                        selectButtonText="Select File(s)"
                        class="attachments"
                        accept="*"
                        uploadMode="instantly"
                        [showFileList]="false"
                        [multiple]="true"
                        [uploadUrl]="serviceName + '/api/utility/uploadCommitteeAttachment/' + committeeId"
                        [uploadHeaders]="uploadHeaders"
                        (onUploadStarted)="uploadStarted($event)"
                        (onUploadError)="uploadError($event)"
                        (onUploaded)="uploaded($event)"
                    >
                    </dx-file-uploader>
                </div>
            </dxi-item>
        </dxi-item>
        }
    </dx-form>
</div>
<div class="modal-footer">
    <button class="btn btn-primary" (click)="save()" [disabled]="processing">Save</button>
    <button class="btn btn-secondary" (click)="close()" [disabled]="processing">Cancel</button>
</div>
